import React from 'react';
import ActionMenu from '../../../common/action/ActionMenu';
import StatusCell from '../../../common/cells/StatusCell';
import StateMultiSelectColumnFilter, { StateMultiSelectFilterFn } from '../../../common/filters/StateMultiSelectColumnFilter';
import TextColumnFilter from '../../../common/filters/TextColumnFilter';

export const columns = (refresh) => {
    return [
        {
            Header: 'Státusz',
            accessor: 'state',
            id: 'state',
            show: true,
            className: 'status',
            Filter: StateMultiSelectColumnFilter,
            filter: StateMultiSelectFilterFn,
            Cell: props => <StatusCell row={props.row.original} />,
        },
        {
            Header: 'Megnevezés',
            accessor: 'name',
            id: 'name',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Megjegyzés',
            accessor: 'comment',
            id: 'comment',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            id: 'menu',
            show: true,
            className: 'actions',
            Header: () => null, // No header
            Cell: value => <ActionMenu row={value.row.original} tabletype={'category'} refresh={refresh} />,
        },
    ]
}